import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Theme from "../../styles/Theme/Theme";
import useFetch from "../../server/useFetch";
import { PageContent, PageSection, PageTitle } from "../../styles/global/Pages.styled";
import { Col, Flex, Row } from "antd";
import { Text } from "../Global/Atomics/Text";
import { ComplexTable } from '@synergy/table';
import { ComparativeAnalysis } from "../Global/Molecules/Analytic/ComparativeAnalysis";
import query from "../../server/constants.api";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { FiltersAnalysis } from "../Global/Molecules/Analytic/FiltersAnalysis";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 100%;
  background-color: ${Theme.color["neutral-1"]};
`;

const RightContent = styled.div`
 display:flex;
 flex-direction:column;
 justify-content:space-between;
  width: calc(100% - 235px);
  overflow-y:auto;
  .tab_component_children {
    padding: ${Theme.spacing.s05};
    box-sizing: border-box;
  }
`;

export const Analytic = () => {
  const { t } = useTranslation(); // Translation hook
  const [selectedItems, setSelectedItems] = useState([]);
  const [filtersSelected, setFiltersSelected] = useState(null);
  const limitCheckboxes = 4;

  const {
    data: registryData,
    isFetching: registryIsFetching,
    refetch: refetchRegistryData,
    isError: registryIsError,
  } = useFetch('/items', 'getAnalyticRegistryData', {
    tenant: "NOVA - Campus de Campolide",
  }, null, null, query.middlewareURL); // Custom hook for fetching complex table data

  // Custom input object for ComplexTable component
  const customInput = { placeholder: t('search') }

  // Function to handle row selection in table
  const onRowSelect = (record, selected, selectedRows) => {
    try {
      if(selectedItems.find(item => item.id === record.id)) {
        setSelectedItems(selectedItems.filter(item => item.id !== record.id));
      } else {
        setSelectedItems([...selectedItems, {id: record.id, name: record.name}]); // Update selected items state with selected rows
      }
    } catch (error) {
      console.error('(Analytic page) Error handling table row selection:', error);
    }
  };

  return (
    <PageContent>
      {/* Page section for filters and table */}
      <PageSection>
        {/* Flex layout for page title and filters */}
        <Flex align="center" justify="space-between">
          {/* Page title */}
          <PageTitle>
            <div className="title">
              <Text $fontColor='coolgray-12' $fontSize='text_xl' $weight='regular' $marginRight='s03' $marginBottom='s08'>{t('analytics')}</Text>
            </div>
          </PageTitle>
        </Flex>
        {/* Row for complex table */}
        <Row gutter={[32, 32]}>
          <Col span={24} >
            <ComplexTable fetchData={registryData?.map(x => { return { ...x, class: t(x.class), layer: t(x.layer) } })} hrefLink='/home/register/registerDetail/${id}'
              getFromChildSelectedValues={null} onRowSelect={onRowSelect} customInput={customInput}
              language={i18next.resolvedLanguage} hasCheckbox={true} pagination={true} defaultPageSize={10} isLoading={registryIsFetching}
              tableConfiguration={tableConfig} limitCheckboxes={limitCheckboxes} />
          </Col>
        </Row>
        <FiltersAnalysis selectedItems={selectedItems} filtersSelected={(values) => { setFiltersSelected(values) }} limitCheckboxes={limitCheckboxes} />
      </PageSection >
      {/* Conditional rendering of charts section */}
      {filtersSelected ?
        <PageSection >
          <Row gutter={[32, 32]}>
            {/* <GeneralCumulativeAnalysis filtersSelected={filtersSelected} /> */}
            <ComparativeAnalysis filtersSelected={filtersSelected} />
          </Row>
        </PageSection > : null}
    </PageContent>
  );
}

const tableConfig = {
  collumnsConfiguration: [
      {
          "title": "Nome",
          "dataIndex": "name",
          "filterMultipleSelect": false
      },
      {
          "title": "Layer",
          "dataIndex": "layer",
          "filterMultipleSelect": false
      },
      {
          "title": "Tipologia",
          "dataIndex": "class",
          "filterMultipleSelect": false
      }
  ],
  hideSelectAll: false
};